import _ from 'underscore';
import { generate } from './readonly-computed';

/**
 * extend the observable for visible
 * @param {Observable} local - observable define for property
 * @param {Object} attrs - property define
 * @param {FieldOption} fieldOption - field of property
 * @param {Object} viewModel - model value of entity
 * @returns {undefined} - the function extend passed local directly
 */
export function visible(local, attrs, fieldOption, viewModel) {
  _.extend(local, {
    visible: generate(fieldOption.visible, viewModel),
  });
}
